var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

/**
 * Initializes the site header.
 * @constructor
 * @param {Object} el - The site header element.
 */
function CuratedEvents(el) {
  this.el = el;
  this.$el = $(el);


}

module.exports = CuratedEvents;